var getLatestComment = function (comments) {
    return comments.sort(function (a, b) { return b.createdDate - a.createdDate; })[0];
};
var getOldestComment = function (comments) {
    return comments.sort(function (a, b) { return a.createdDate - b.createdDate; })[0];
};
export var containsNewComment = function (previous, current) {
    var latestPrevious = getLatestComment(previous || []);
    var latestCurrent = getLatestComment(current || []);
    if (!latestPrevious) {
        return !!latestCurrent;
    }
    else {
        return latestPrevious.id !== latestCurrent.id;
    }
};
export var containsOlderComment = function (previous, current) {
    var oldestPrevious = getOldestComment(previous || []);
    var oldestCurrent = getOldestComment(current || []);
    if (!oldestPrevious) {
        return !!oldestCurrent;
    }
    else {
        return oldestPrevious.id !== oldestCurrent.id;
    }
};
export var isMyComment = function (user, comment) {
    return comment.createdBy.id === user.id;
};
export var hasCommentValidValue = function (value) {
    return value.trim().length > 0;
};
//# sourceMappingURL=utils.js.map